let counter = 0

export const uniqueIdentificationGenerator = (prefix = '') => {
  counter += 1
  return `${prefix}${counter}`
}
